import { createApiRef } from '@backstage/core-plugin-api';

export type PowerPreset = {
  title: string;
  description: string;
  value: number;
};

export type StatsConfigApi = {
  powerPresets: readonly PowerPreset[];
};

export const statsConfigApiRef = createApiRef<StatsConfigApi>({
  id: 'plugin.confidence-workflows-module-stats.config',
});
